import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createarray">
                1.&nbsp;<span className="material-symbols-outlined">data_array</span>&nbsp;{translate('createarray')}
            </Typography>
            <p><strong>{translate('createarray')}</strong> is an action that is used to create an array.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$array_1</td>
                            </tr>
                            <tr>
                                <td>{translate('array')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>A list of values to create an array.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$array_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('array')}</span>
                            <div>["red", "green", "blue"]</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "red"
                                            ,"green"
                                            ,"blue"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getelementfromarray">
                2.&nbsp;<span className="material-symbols-outlined">question_mark</span>&nbsp;{translate('getelementfromarray')}
            </Typography>
            <p><strong>{translate('getelementfromarray')}</strong> is the act of locating an element from an array and retrieving its value.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$element_1</td>
                            </tr>
                            <tr>
                                <td>{translate('arraydata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Is an array.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('arrayindex')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the index of the element to be retrieved (starting from 0).</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('arraydata')}</span>
                            <div>array_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('arrayindex')}</span>
                            <div>0</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>red</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="createobject">
                3.&nbsp;<span className="material-symbols-outlined">data_object</span>&nbsp;{translate('createobject')}
            </Typography>
            <p><strong>{translate('createobject')}</strong> is an action that is used to create an object.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$object_1</td>
                            </tr>
                            <tr>
                                <td>{translate('object')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>A list of key/value pairs to create an object.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Creates an object with <strong>key</strong> respectively <i>product</i>, <i>color</i> and <strong>value</strong> respectively <i>pen</i>, <i>blue</i>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$object_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('object')}</span>
                            <div>{ `{"product": "pen", "color": "blue"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "product": "pen", 
                                            "color": "blue"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getvaluefromobject">
                4.&nbsp;<span className="material-symbols-outlined">question_mark</span>&nbsp;{translate('getvaluefromobject')}
            </Typography>
            <p><strong>{translate('getvaluefromobject')}</strong> is an action that takes a value from an object by specifying <strong>key</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$value_1</td>
                            </tr>
                            <tr>
                                <td>{translate('objectdata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is an object.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('objectkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>key</strong> name</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$value_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('objectdata')}</span>
                            <div>object_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('objectkey')}</span>
                            <div>product</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>pen</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);